import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  goToDebitForm: any;
  goToApplication: any;
  goToPackages: any;
  currentUrl: any;
  previousUrl: any;
  gotoProfileDetails() {
    throw new Error('Method not implemented.');
  }

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      }
    });
  }

  getPreviousUrl() {
    this.router.navigate([this.previousUrl])
  }

  register() {
    this.router.navigate(['/auth/register'])
  }

  login() {
    this.router.navigate(['/auth/login'])
  }
  checkout() {
    this.router.navigate(['/newHomeShopping/cart/checkout'])
  }
  gotocart() {
    this.router.navigate(['/newHomeShopping/cart'])
  }

  enroll() {
    this.router.navigate(['/enroll'])
  }

  customerDetails() {
    this.router.navigate(['/checkcoverage/customer-details'])
  }

  coverage() {
    this.router.navigate(['/coverage'])
  }

  resellerapplication() {
    this.router.navigate(['/resellerapplication'])
  }

  dashboard() {
    this.router.navigate(['/dashboard'])
  }
  //   goToApplicationCompleted(referenceid,israin){
  //     this.router.navigate(['/dashboard/'+ referenceid +'/' + israin])
  //   }
  goToApplicationCompleted() {
    this.router.navigate(['/dashboard'])
  }

  internetAccDetails() {
    this.router.navigate(['/pppoeDetails'])
  }

  checkCoverage(id) {
    this.router.navigate(['/checkcoverage/coverage/' + id])
  }

  packages() {
    this.router.navigate(['/checkcoverage/packages'])
  }

  fiberPage(id) {
    this.router.navigate(['/fibre/fibre-form/' + id])
  }

  billinginfo() {
    this.router.navigate(['/billingInformation'])
  }
  support() {
    this.router.navigate(['/support'])
  }

  shop() {
    this.router.navigate(['/newHomeShopping'])
  }
  movingAddress() {
    this.router.navigate(['/addressChange'])
  }
  serviceChange() {
    this.router.navigate(['/upgrade'])
  }
  transfermyAccount() {
    this.router.navigate(['/transferaccount'])
  }
  //   addsupport(id,actioninfo){
  //     this.router.navigate(['/support/'+id+'/'+actioninfo])
  //   }
  addsupport() {
    this.router.navigate(['/support/addsupport'])
  }
  gotolandingpage() {
    this.router.navigate(['/landing'])

  }
  trackorder() {
    this.router.navigate(['/newHomeShopping/track-order'])
  }

  cancellationservice() {
    this.router.navigate(['/cancellationofservice'])
  }

  myaccount(id) {
    this.router.navigate(['/profile/' + id])
  }

  goToManageRequest() {
    this.router.navigate(['managerequest'])
  }

  goToRequestForm(id) {
    this.router.navigate(['managerequest/request/' + id])
  }

  goToLoginDetails(id) {
    this.router.navigate(['homeConnectUser/' + id])
  }

  goToHomeConnectUser() {
    this.router.navigate(['homeConnectUser'])
  }

  goToManageService() {
    this.router.navigate(['serviceprovider'])
  }

  goToManageServiceForm(id, type) {
    this.router.navigate(['serviceprovider/' + id + '/' + type])
  }

  goToManageReseller() {
    this.router.navigate(['reseller'])
  }

  goToManageResellerForm(id) {
    this.router.navigate(['reseller/' + id])
  }

  gotoproductbyId(id: any) {
    this.router.navigate(['/newHomeShopping/products/' + id])
  }
  goToApproval(id) {
    console.log("id from url", id);

    this.router.navigate(['/dashboard/manageapplication/' + id])
  }
  gotomanagefiber() {
    this.router.navigate(['manageapplication/' + 0])
  }
  goToManageRainApplication() {
    this.router.navigate(['/managerainapplication'])
  }
  goToManageTransferAccount() {
    this.router.navigate(['/manageaccounttransfer'])
  }
  goToUploadSelectedFile() {

  }

  gotoaddproduct(id) {
    this.router.navigate(['product/' + id])
  }

  gotomanageproduct() {
    this.router.navigate(['product/'])
  }
  goToManagePromotionForm(id) {
    this.router.navigate(['addBanner/' + id])
  }
  goToShopPromotion() {
    this.router.navigate(['manageshoppromotions/'])
  }


  gotoProductSubId(id) {
    this.router.navigate(['subcategory/' + id])
  }

  gotoProductSub() {
    this.router.navigate(['subcategory/'])
  }

  gotoManageSalesRepAdd(id) {
    this.router.navigate(['salesrep/' + id])
  }

  gotoManageSalesRep() {
    this.router.navigate(['salesrep/'])
  }

  gotoSalesTargetHC(id, type) {
    this.router.navigate(['salestarget/' + id + '/' + type])
  }

  gotoSalesTargetSetup() {
    this.router.navigate(['salestarget/'])
  }

  gotoupgradeapproval(data) {
    data = JSON.stringify(data)
    this.router.navigate(['upgradeapproval/', data])
  }
  goToManageservicechange() {
    this.router.navigate(['manageServiceChangeRequest/' + 1])
  }
  gotomanageCancellation() {
    this.router.navigate(['manageCancellation/' + 1])

  }
  gotoaddActivity(data) {
    this.router.navigate(['addactivity/' + data])
  }
  gotoActivity() {
    this.router.navigate(['activity/'])
  }
  gotomanageactiondetails(data) {
    this.router.navigate(['manageactiondetails/', data])
  }
  gotomanageaction() {
    this.router.navigate(['manageaction/'])
  }
  gotoManageSms() {
    this.router.navigate(['/messaging'])
  }
  gotoaddBankingDetails() {
    this.router.navigate(['addbankingdetails'])
  }
  gotochangebankdetails() {
    this.router.navigate(['viewbankingdetails'])
  }
  gotoaddsuspension() {
    this.router.navigate(['bulksuspendrevoke'])
  }
  gotobulksuspensiorevoke() {
    this.router.navigate(['managebulksuspendrevoke'])
  }
  gotomanagepushnotification() {
    this.router.navigate(['managePushNotification'])
  }
  gotoviewvumartalnetworkevents(data) {
    this.router.navigate(['viewvumatelNetworkEvents/', data])
  }
  gotovumartalnetworkevents() {
    this.router.navigate(['vumatelNetworkEvents'])
  }
  gotoFrogfootcomments(data) {
    this.router.navigate(['frogfootcomments/', data])
  }
  gotoFrogfootactionrequired() {
    this.router.navigate(['frogfootactionrequired'])
  }
  gotoapplicationdetails(applicationId, serviceproviderId?, isReminder?, usdf3?, title?) {
    this.router.navigate(['applicationdetails/' + applicationId + '/' + serviceproviderId + '/' + isReminder + '/' + usdf3 + '/' + title])
  }
  goToDeactivatedApplication() {
    this.router.navigate(['deactivate', 1])
  }
  gotovieworderdetails(data) {
    this.router.navigate(['vieworderdetails/', data])
  }
  gotomanageshoppingorder() {
    this.router.navigate(['manageshopping/', 1])
  }
  gotoaccounttransfer() {
    this.router.navigate(['manageaccounttransfer'])
  }
  goToeditapplication(applicationId) {

  }
  goToRequestView(requestId) {

  }
  goToserviceProvider(applicationId) {
    this.router.navigate(['1sprequest/', applicationId])
  }
  goToAllocateTechnician(applicationId) {
    this.router.navigate(['allocatetechnician/', applicationId])
  }
  goToDeviceAllocation(applicationId) {
    this.router.navigate(['spconfirmdevice/', applicationId])
  }
  goToTechnicianConfirm(applicationId) {
    this.router.navigate(['technicianconfirm/', applicationId])
  }
  goToCourier(applicationId) {
    this.router.navigate(['spconfirmdecourier/', applicationId])
  }
  goToModeOfDispatch(applicationId) {
    this.router.navigate(['spconfirmdespatch/', applicationId])
  }
  goToManageApplication() {

  }
  goToSPConfirmation(applicationId) {
    this.router.navigate(['spconfirm/', applicationId])
  }
  goToViewUsageChart(customerApplicationId) {
    this.router.navigate(['viewUsageChart/' + customerApplicationId])
  }
  gotoActivityDetails(customerApplicationId, page) {
    this.router.navigate(['activitydetails/' + customerApplicationId + '/' + page])
  }
  goToViewSupport(supportId) {
    this.router.navigate(['supportviewsupport/' + supportId])
  }
  goToManagePromotion() {
    this.router.navigate(['managepromotion'])
  }
  goToRelocationPromotion() {
    this.router.navigate(['relocation-promotion']);
  }
  goToManagePromotionAdd(id, type) {
    this.router.navigate(['managepromotionadd/' + id + '/' + type])
  }
  goTopromotionsimulation(id, type) {
    this.router.navigate(['promotionsimulation/' + id + '/' + type])
  }
  goTonetworkoutage() {
    this.router.navigate(['networkoutage/'])
  }
  goToaddnetworkoutage(id) {
    this.router.navigate(['addnetworkoutage/' + id])
  }
  goTomanageRelocationPromotion() {
    this.router.navigate(['manage-relocation-promotion/'])
  }
  goToLoginauth() {
    this.router.navigate(['auth/loginauth'])
  }
  goToSuspensionSchedule() {
    this.router.navigate(['createSuspensionSchedule'])
  }
  goToSuspensionDashboard() {
    this.router.navigate(['/suspensionDashboard'])
  }

  goToManageResellerSalesForm(id: number, mode: number) {
    this.router.navigate(['/reseller-sales', id, mode]);
  }

  goToManageResellerSales() {
    this.router.navigate(['reseller-sales'])
  }
  goToAddBankingDetailsFromManageFibre(applicationId: number) {
    this.router.navigate(['addbankingdetails/' + applicationId])
  }
}
